/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Storage_ErrorInputs */

const en_iconik_publish_storage_error = /** @type {(inputs: Iconik_Publish_Storage_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ERROR: Unable to publish | Access to storage denied.`)
};

const fr_iconik_publish_storage_error = /** @type {(inputs: Iconik_Publish_Storage_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ERREUR : Impossible de publier | Acces au stockage refuse.`)
};

const de_iconik_publish_storage_error = /** @type {(inputs: Iconik_Publish_Storage_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FEHLER: Veröffentlichung nicht möglich | Zugriff auf den Speicher verweigert.`)
};

const it_iconik_publish_storage_error = /** @type {(inputs: Iconik_Publish_Storage_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ERRORE: Impossibile pubblicare | Accesso all'archiviazione negato.`)
};

const ru_iconik_publish_storage_error = /** @type {(inputs: Iconik_Publish_Storage_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ОШИБКА: Невозможно опубликовать | Доступ к хранилищу запрещен.`)
};

const es_iconik_publish_storage_error = /** @type {(inputs: Iconik_Publish_Storage_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ERROR: No se puede publicar | Acceso al almacenamiento denegado.`)
};

const zh_cn2_iconik_publish_storage_error = /** @type {(inputs: Iconik_Publish_Storage_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误：无法发布 | 存储访问被拒绝。`)
};

const ja_iconik_publish_storage_error = /** @type {(inputs: Iconik_Publish_Storage_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラー: 公開できません | ストレージへのアクセスが拒否されました。`)
};

const hi_iconik_publish_storage_error = /** @type {(inputs: Iconik_Publish_Storage_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`त्रुटि: प्रकाशित करने में असमर्थ | संग्रहण तक पहुंच अस्वीकृत।`)
};

const pt_pt2_iconik_publish_storage_error = /** @type {(inputs: Iconik_Publish_Storage_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ERRO: Não foi possível publicar | Acesso ao armazenamento negado.`)
};

/**
* | output |
* | --- |
* | "ERROR: Unable to publish \| Access to storage denied." |
*
* @param {Iconik_Publish_Storage_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_storage_error = /** @type {((inputs?: Iconik_Publish_Storage_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Storage_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_storage_error(inputs)
	if (locale === "de") return de_iconik_publish_storage_error(inputs)
	if (locale === "it") return it_iconik_publish_storage_error(inputs)
	if (locale === "ru") return ru_iconik_publish_storage_error(inputs)
	if (locale === "es") return es_iconik_publish_storage_error(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_storage_error(inputs)
	if (locale === "ja") return ja_iconik_publish_storage_error(inputs)
	if (locale === "hi") return hi_iconik_publish_storage_error(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_storage_error(inputs)
	return en_iconik_publish_storage_error(inputs)
});